/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);



/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/util/inDOM.js
 ** module id = 127
 ** module chunks = 0
 **/